export default function getAsBase64(image) {
    if (image == null) {
        return Promise.resolve(image);
    }

    // Exception for svg placeholder
    if (image.toString().indexOf('.svg') !== -1) {
        return Promise.resolve(image);
    }

    return fetch(image, { mode: 'cors' })
        .then((response) => {
            if (response.ok) {
                return response.blob();
            }

            throw new Error(`Could not load ${image}`);
        })
        .then((blob) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = () => {
                reject();
            };
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.readAsDataURL(blob);
        }));
}
